import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Box, Typography, Modal } from '@mui/material';

import UnsubscribeIcon from '../../../../common/assets/icons/unsubscribe_icon.svg';

import './SubscriptionPurchasedModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  loading: boolean;
};

const DeleteAccountConfirmation: React.FC<Props> = ({
  open,
  onClose,
  onAccept,
  loading,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div>
          <img src={UnsubscribeIcon} alt='Unsubscribe' />
          <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
            You are about to delete your account
          </Typography>
          <Typography color='gray'>
            Are you sure you want to delete your account?
          </Typography>
          <Button
            onClick={onAccept}
            variant='contained'
            color='error'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>Yes, delete my account</Typography>
          </Button>
          <LoadingButton
            onClick={onClose}
            variant='contained'
            color='secondary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '10px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>No, thank you</Typography>
          </LoadingButton>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteAccountConfirmation;
